import * as React from "react";
import { Field,  Control, Input, Button } from "bloomer";
import { Container, Header, FormContainer, Switch } from "./Styles";
import { BACKEND_URI } from "../../utils/Constants";
import { Redirect } from "react-router";
import { isLoggedIn } from "../../utils/auth";
import styled from "react-emotion";

const ErrorMessage = styled("div")`
  margin-top: -25px;
  text-align: center;
  line-height: 30px;
  vertical-align: middle;
  color: red;
  width: 90%;
`;

const SuccessMessage = styled("div")`
  margin-top: -25px;
  text-align: center;
  line-height: 30px;
  vertical-align: middle;
  width: 90%;
`;

class ForgotPassword extends React.Component {
  public props: {
    switch(value: string): void;
  };

  public state = {
    email: "",
    responseError: false,
    success: false,
    errorMessage: ""
  };

  public handleEmailChange(event: React.FormEvent<HTMLInputElement>) {
    this.setState({
        email: event.currentTarget.value,
        errorMessage: ""
    });
  }

  public onLoggedIn = (data: { success: boolean }) => {
    if (!data.success) {
        this.setState({responseError: true})
    } else {
        this.setState({success: true})
    }
  };

  public handleSubmit = () => {
    const {  email } = this.state;

    this.setState({
        responseError: false,
        success: false
    });

    if (!email) {
      this.setState({
          errorMessage: "Please enter email."
      });
      return;
    }

    fetch(`${BACKEND_URI}/auth/reset`, {
      body: JSON.stringify({ email }),
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST"
    })
      .then(response => response.json())
      .then(this.onLoggedIn)
      .catch(() => {
        this.setState({
          responseError: true,
          success: false
        })
      });
  };

  public render() {
    return (
      <Container>
        <Header>Password Reset</Header>
        <span>Enter your e-mail to receive new password.</span>
        <FormContainer>
          <Field>
            <Control style={{marginTop: "25px", marginBottom: "15px"}}>
              <Input
                type="text"
                placeholder="your e-mail"
                value={this.state.email}
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                  this.handleEmailChange(e)
                }
              />
            </Control>
          </Field>
        </FormContainer>
          {
              this.state.errorMessage && <ErrorMessage>{this.state.errorMessage}</ErrorMessage>
          }
        {
          this.state.responseError && <ErrorMessage>There was an error! Please try again.</ErrorMessage>
        }
        {
          this.state.success && <SuccessMessage>Password reset successful.</SuccessMessage>
        }
        <Button style={{ margin: "15px" }} onClick={this.handleSubmit}>
          Submit
        </Button>
        <div>
          <Switch onClick={() => this.props.switch("login")}>Sign In</Switch>
          {" "}or{" "}
          <Switch onClick={() => this.props.switch("signup")}>Sign Up</Switch>
          {" "}instead
        </div>
        {isLoggedIn() && <Redirect to="/models" />}
      </Container>
    );
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/routes/Login/ForgotPassword.tsx